<!-- Page body: hosts the CommissionRule object component once the identifier is resolved (FR-3/FR-4). -->
@if (objectIdentifier) {
    <mvs-cn-commission-rule-object-component
            [objectIdentifier]="objectIdentifier">
    </mvs-cn-commission-rule-object-component>
}
